<lg-icon
    class="ordered-item__drag-icon"
    [style.visibility]="isDisabled() ? 'hidden' : 'visible'"
    [icon]="'icon-draggable'"
    cdkDragHandle
/>

<span class="ordered-item__text">
    <b>{{ this.itemPosition() }}</b>

    <span lgSimpleOverflowTooltip>
        {{ this.menuItem()?.name ?? this.menuItem()?.id ?? this.selectedItem() }}
    </span>
</span>

<button
    class="ordered-item__remove-button"
    [style.visibility]="isDisabled() ? 'hidden' : 'visible'"
    (click)="_onRemoveItem($event)"
>
    <lg-icon class="ordered-item__remove-icon" [icon]="'icon-cancelled-state'" />
</button>
